import React from 'react';
import { MaskedLink, VerticalListing } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import formatPrice from '../../../../utils/formatPrice';
import { getLargeImageUrl } from '../../../../utils/getImageUrls';
import { trackGAEvent } from '../../../../utils/gaTracking';
import { TAdmarktItem } from 'types/TAdmarkt';
import { TFeedItem } from 'types/TFeeds';

type TAdmarktSimilarItemProps = {
  item: TAdmarktItem | TFeedItem;
};

const AdmarktSimilarItem = ({ item }: TAdmarktSimilarItemProps) => {
  const { t } = useI18nContext();
  const formattedPrice = formatPrice(item.price, t);
  const imageUrl = item.picture
    ? getLargeImageUrl(typeof item.picture === 'string' ? item.picture : item.picture.url)
    : undefined;
  const handleClick = () => {
    trackGAEvent('Click', 'RecommendedItemBlock');
  };
  return (
    <MaskedLink kind="block" href={item.url} onClick={handleClick}>
      <VerticalListing
        title={item.title}
        price={formattedPrice}
        imageSrc={imageUrl}
        imageLoading="lazy"
        decoding="async"
      />
    </MaskedLink>
  );
};

export default AdmarktSimilarItem;
